import { Injectable } from '@angular/core';
import { Proper } from '../../../objects';
import { ApiService } from '../../../services/api.service';

@Injectable()
export class ProperService {

  private cache: Proper[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<Proper[]> {

    const p = new Promise<Proper[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("Proper cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/Proper/", null).subscribe(
        (data: Proper[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;
}


}
